module.exports = __webpack_public_path__ + "static/media/80486DX4.34492b3a.jpg";